module.exports = __webpack_public_path__ + "media/images/no_logo-0cb897e4.png";